import React, { useMemo } from "react";
import { observer } from "mobx-react-lite";

import { translationService } from "../../services/translation/TranslationService";

interface DataGridNoResultsProps {
  itemTypeKey: string;
  insideDialog?: boolean;
  messageKey?: string;
}

export default observer(function DataGridNoResults(props: DataGridNoResultsProps) {
  const { itemTypeKey, insideDialog = false, messageKey = "" } = props;

  const translatedItemType = translationService.translate(itemTypeKey);

  const displayResultCount = useMemo(() => {
    if (insideDialog) return null;
    return (
      <section className="data-grid-total-results">
        <h3>
          {translationService.translate("general.list.total-results-items", {
            itemType: translatedItemType,
            totalResults: 0,
          })}
        </h3>
      </section>
    );
  }, [insideDialog, translatedItemType]);

  return (
    <div>
      {displayResultCount}
      <section>
        <div id="empty-table" className="data-grid-no-results">
          {messageKey
            ? translationService.translate(messageKey)
            : translationService.translate("general.list.no-added-items", {
                itemType: translatedItemType,
              })}
        </div>
      </section>
    </div>
  );
});
